import React, { useState, useEffect } from "react";
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import { Box, Typography, TextField, DialogActions, Button, Grid, Tooltip } from "@mui/material";
import { alpha, styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import moment from "moment";
import { postData, putData } from "../../../../services/library";
import PublicIcon from '@mui/icons-material/Public';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import ChecklistIcon from '@mui/icons-material/Checklist';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import DialogNuevo from "./Observaciones/DialogNuevo";
import DeleteIcon from '@mui/icons-material/Delete';
import { UrlApi } from "../../../../services/apirest";
import SinObs from "./Observaciones/SinObs";


const CustomSwitch = styled(Switch)(({ theme }) => ({
    "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#164e63",
        "&:hover": {
            backgroundColor: alpha("#164e63", 0.08),
        },
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#164e63",
    },
    "& .MuiSwitch-track": {
        backgroundColor: "#475569",
    },
}))

const ADMIN_COLOR = "#dbcac9ff";

const label = { inputProps: { 'aria-label': 'Color switch demo' } };

export default function DialogObservacionesInternas(props) {
    const { pedido } = props;

    const currentUser = localStorage.getItem("user");
    const [obsInternas, setObsInternas] = useState([]);
    const [nuevaObsInterna, setNuevaObsInterna] = useState({ observaciones: "", usuario: currentUser, activo: 1, uuid_pedido: pedido.uuid_pedido, privada: 1 });
    const [notificacion, setNotificacion] = useState({});

    const getObsInternas = async (pedido) => {
        await fetch(`${UrlApi}/observaciones_pedidos/${pedido.uuid_pedido}`)
            .then((data) => data.json())
            .then((data) => setObsInternas(data.filter((obs) => (obs.usuario === currentUser) || obs.privada === 0 || obs.privada === null)))
    }

    useEffect(() => {
        getObsInternas(pedido)
    }, [pedido]);


    const handleEliminarObservacion = async (e, obs) => {
        await putData(e, `/observaciones_pedidos/${obs.id}`, { activo: 0 }, setNotificacion);
        getObsInternas(pedido)
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        await postData(
            event,
            `/observaciones_pedidos/`,
            nuevaObsInterna,
            setNotificacion
        );
        setNuevaObsInterna({ observaciones: "", usuario: currentUser, activo: 1, uuid_pedido: pedido.uuid_pedido, privada: 1 });
        getObsInternas(pedido)
    };


    const children = () => {
        return (
            <>
                {obsInternas?.length === 0 && (
                    <SinObs />
                )}
                {obsInternas?.map((obs) => (
                    <>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 2,
                                px: 3,
                                py: 2,
                                "&:hover": { bgcolor: "#e6dedeff" },
                                transition: "background-color 0.15s",
                            }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    gap: 0.5,
                                    pt: 0.25,
                                }}
                            >
                                <Avatar
                                    sx={{
                                        bgcolor: ADMIN_COLOR,
                                        width: 34,
                                        height: 34,
                                    }}
                                >
                                    <ManageSearchIcon sx={{ fontSize: 24 }} />
                                </Avatar>
                            </Box>

                            <Box
                                sx={{
                                    flex: 1,
                                    minWidth: 0,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.3,
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                    }}
                                >
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: 700,
                                            color: "#333",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {obs.usuario}
                                    </Typography>

                                    {obs?.created_at && (
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                color: "#888",
                                                fontSize: 11,
                                                whiteSpace: "nowrap",
                                            }}
                                        >
                                            {moment(obs.created_at).format("DD/MM/YYYY HH:mm:ss")}
                                        </Typography>
                                    )}
                                </Box>

                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "#555",
                                        lineHeight: 1.5,
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {obs.observaciones}
                                </Typography>
                            </Box>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    ml: 1,
                                    color: obs.privada ? "#164e63" : "#a77067ff",
                                }}
                            >
                                {obs.privada ? (
                                    <>
                                        <Tooltip title="Observación privada">
                                            <LockPersonIcon sx={{ color: "#164e63" }} />
                                        </Tooltip>
                                    </>
                                )
                                    : (
                                        <>
                                            <Tooltip title="Observación pública" >
                                                <PublicIcon sx={{ color: "#a77067ff" }} />
                                            </Tooltip>
                                        </>
                                    )

                                }
                            </Box>

                            {obs.usuario === currentUser && (
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        ml: 1,
                                        color: obs.privada ? "#164e63" : "#a77067ff",
                                    }}
                                >
                                    <Tooltip title="Eliminar Observación">
                                        <DeleteIcon sx={{ color: "#722519ff" }} onClick={(e) => handleEliminarObservacion(e, obs)} />
                                    </Tooltip>
                                </Box>
                            )}
                        </Box>
                    </>
                ))}
                <Divider />
                <form onSubmit={handleSubmit}>
                    <Box sx={{ p: 2 }}>
                        <Grid container direction="row" p={2} alignItems="center" justifyContent={"space-between"} backgroundColor="#ebebeb" borderRadius={4}>
                            <Grid item xs={9} >
                                <TextField
                                    multiline
                                    rows={2}
                                    sx={{ backgroundColor: "#fff" }}
                                    fullWidth
                                    autoFocus
                                    required
                                    margin="dense"
                                    name="observacion"
                                    label="Nueva Observación"
                                    value={nuevaObsInterna.observaciones}
                                    onChange={(e) => setNuevaObsInterna({ ...nuevaObsInterna, observaciones: e.target.value })}
                                    type="text"
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Grid container alignItems="center" justifyContent="space-between" direction="row">
                                    <Grid item xs={3}>
                                        <Typography
                                            sx={{
                                                color: "#164e63",
                                                fontWeight: 500,
                                                fontSize: "16",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px",
                                            }}
                                        >
                                            Privada
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={4} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                        <CustomSwitch
                                            checked={nuevaObsInterna.privada}
                                            onChange={(e) => {
                                                const checked = e.target.checked;
                                                setNuevaObsInterna({ ...nuevaObsInterna, privada: checked });
                                            }}
                                            {...label}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>

                    <DialogActions>
                        <Button
                            variant="contained"
                            color="primary"
                            type="submit"
                            sx={{
                                borderRadius: "10px",
                                padding: "10px 32px",
                                textTransform: "none",
                                fontWeight: 600,
                                fontSize: "0.95rem",
                                backgroundColor: "#164e63",
                                boxShadow: "0 4px 12px rgba(22, 78, 99, 0.25)",
                                "&:hover": {
                                    backgroundColor: "#0c3a47",
                                    boxShadow: "0 6px 16px rgba(22, 78, 99, 0.35)",
                                },
                                "&:disabled": {
                                    backgroundColor: "#cbd5e1",
                                    color: "#94a3b8",
                                },
                            }}
                        >
                            Guardar Observación
                        </Button>
                    </DialogActions>
                </form>
            </>
        )
    }

    return (
        <DialogNuevo
            open={props.open}
            handleClose={props.handleClose}
            titulo="Observaciones Internas"
            subtitulo={`Pedido #${pedido?.idpedido}`}
            icono={<ChecklistIcon sx={{ fontSize: 22 }} />}
            children={children()}
        />
    )
} 